<!--<router-outlet></router-outlet>-->
<app-nav-bar/>
<app-hero-section/>
<app-team-home/>
<app-services-home/>
<app-promotions-featured/>
<app-our-clients/>
<app-footer-persona/>
<app-float-button/>
